<template>
  <div class="corner" :class="'lang-'+lang" :title="labels['translate']" @click="switchLanguage">
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { LABELS } from '@/settings'

export default {
  computed: mapState({
    lang: state => state.language,
    labels: state => LABELS[state.language]
  }),
  methods: {
    switchLanguage () {
      const currentLang = this.lang
      const lang = currentLang === 'ru' ? 'en' : 'ru'
      this.$store.dispatch('switchLanguage', lang)
    }
  }
}
</script>

<style>
  .oi-donation-form .corner:before {
    content: '';
    display: inline-block;
    -webkit-clip-path: polygon(0 0, 35px 35px, 35px 0);
    clip-path: polygon(0 0, 35px 35px, 35px 0);
    height: 35px;
    width: 35px;
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
    background-size: 33px 33px;
    background-position: top right;
    background-repeat: no-repeat;
  }

  .oi-donation-form .corner.lang-ru:before {
    background-image: url('../../assets/en.png');
  }
  .oi-donation-form .corner.lang-en:before {
    background-image: url('../../assets/ru.png');
  }
</style>
